import { gql } from "@apollo/client";

import { SIP_FRAGMENT } from "./investment";

export const GOAL_FRAGMENT = gql`
  ${SIP_FRAGMENT}
  fragment GoalFragment on Goal {
    id
    name
    description
    type
    targetAmountInCents
    currentAmountInCents
    startDate
    endDate
    projectedRateOfReturn
    contributionsAfter18
    status
    shared
    partners {
      id
      firstName
      lastName
      recurringDepositInCents
      recurringDepositSchedule
      contributionsInCents
      accountType
      currentAmountInCents
    }
    sips {
      ...SipFragment
    }
    accounts {
      id
      type
      balanceInCents
      title
      accountNumber
      contributionsManagedExternally
      inAppContributionsAllowed
      isHalfmoreSetupPending
      needsPayrollSetup
      harvestStandardDeduction
      harvestLongTermCapitalGains
      harvestRecommendedFloorUsd
      subaccounts {
        id
      }
    }
    estimatedIrsBillInCents
    trumpAccountBalanceInCents
    trumpContributionAmountInCents
    trumpContributionFrequency
  }
`;

export const INVITE_FRAGMENT = gql`
  fragment InviteFragment on SentShareGoalInvite {
    id
    goalId
    phoneNumber
    status
    expiry
  }
`;
